// extracted by mini-css-extract-plugin
export default {"shortBtn":"ButtonBack_shortBtn__MbSQx"};